import initialState from "./initialState";
import * as types from "../constants/actionTypes";

export default function consumableReducer(state = initialState.consumable, action) {
  switch (action.type) {
    case types.UPDATE_PROFILE_BOOST_PRODUCTS: {
      return state.set('profileBoostProducts', action.product);
    }
    case types.UPDATE_CONVERSATION_BOOST_PRODUCTS: {
      return state.set('conversationBoostProducts', action.product);
    }
    case types.UPDATE_GENDER_TYPE_CHANGE_PRODUCTS: {
      return state.set('genderTypeChangeProducts', action.product);
    }
    case types.UPDATE_LIKE_PRODUCTS: {
      return state.set('likeProducts', action.product);
    }
    case types.UPDATE_FAV_PRODUCTS: {
      return state.set('favProducts', action.product);
    }
    case types.UPDATE_INVITES_CREDIT_PRODUCTS: {
      return state.set('invitesCreditProducts', action.product);
    }
    default:
      return state;
  }
}